import { createContext, useContext, useMemo } from "react";
import { TamaguiProvider } from "@tamagui/core";
import { PortalProvider } from "@tamagui/portal";
import { ToastProvider, ToastViewport } from "@tamagui/toast";
import config from "./tamagui.config";
import { jsx, jsxs } from "react/jsx-runtime";
const noopTrackJourneyEvent = () => {
}, defaultAnalyticsContext = {
  useObservability: () => ({
    trackJourneyEvent: noopTrackJourneyEvent
  })
}, AnalyticsContext = createContext(defaultAnalyticsContext), useAnalyticsContext = () => useContext(AnalyticsContext);
function BricksProvider({
  children,
  useObservability,
  toastViewportProps,
  ...rest
}) {
  useObservability = useObservability ?? defaultAnalyticsContext.useObservability;
  const context = useMemo(
    () => ({
      useObservability
    }),
    [useObservability]
  );
  return /* @__PURE__ */ jsx(AnalyticsContext.Provider, { value: context, children: /* @__PURE__ */ jsx(TamaguiProvider, { config, defaultTheme: "light", ...rest, children: /* @__PURE__ */ jsx(PortalProvider, { children: /* @__PURE__ */ jsxs(ToastProvider, { children: [
    children,
    /* @__PURE__ */ jsx(
      ToastViewport,
      {
        flexDirection: "column",
        top: 0,
        left: 0,
        right: 0,
        ...toastViewportProps
      }
    )
  ] }) }) }) });
}
export {
  AnalyticsContext,
  BricksProvider,
  defaultAnalyticsContext,
  useAnalyticsContext
};
